import { useState } from "react";

import { useInterval } from "hooks/use_interval";

export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useInterval(
    () => {
      setCurrentTime(new Date());
    },
    1000,
    true,
  );

  return currentTime;
};
